import { jsx } from '@emotion/react/jsx-runtime';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { useCss } from '@nettbureau/styling';

/**
 * The container centers your content horizontally and adds outer spacing.
 */ const Container = createPolymorphicComponent((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('Container', props, ref);
    const { as: Component = 'div', children, css, maxWidth = 'md', padding = 'lg', ...otherProps } = mergedProps;
    const containerCss = useCss(({ mixins })=>[
            mixins.spacing({
                padding,
                margin: {
                    x: 'auto'
                }
            }),
            mixins.size({
                maxWidth,
                width: '100%'
            })
        ]);
    return /*#__PURE__*/ jsx(Component, {
        "data-container": true,
        ...otherProps,
        ref: mergedRef,
        css: [
            containerCss,
            css
        ],
        children: children
    });
});

export { Container };
//# sourceMappingURL=container.js.map
